export const SET_BALANCE_HISTORY_PAGINATION_TOTAL_RECORDS = "SET_BALANCE_HISTORY_PAGINATION_TOTAL_RECORDS"
export const SET_BALANCE_HISTORY_PAGINATION_PAGE_SIZE = "SET_BALANCE_HISTORY_PAGINATION_PAGE_SIZE"
